var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column col-12 col-mx-auto"},[_c('write-post')],1)]),_c('div',{staticClass:"bottom-padd"})])}
var staticRenderFns = []

export { render, staticRenderFns }